// Here is a list of the toolbar
// Detail list see https://www.tinymce.com/docs/advanced/editor-control-identifiers/#toolbarcontrols

const toolbar = ['layout bold italic underline strikethrough alignleft aligncenter alignright outdent indent styleselect fontsizeselect blockquote undo redo', 'code searchreplace codesample hr bullist numlist link image charmap preview anchor pagebreak insertdatetime media table emoticons forecolor backcolor fullscreen importword']

export default toolbar
